import React from 'react';
import PropTypes from 'prop-types';
import { Typography, IconError, SpacerVertical } from '@klarna/bubble-ui';
import { Column, Row } from 'mage-components';
import styled from 'styled-components';
const MessageContent = styled.div.withConfig({ displayName: "MessageContent", componentId: "sc-1ofwmmn" }) `
  display: flex;
  justify-content: flex-start;
  gap: 5px;
`;
export const ErrorMessage = ({ message }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Column, { columns: { desktop: 12, tablet: 12, mobile: 12 } },
                React.createElement(MessageContent, { "data-testid": "error-message-content" },
                    React.createElement(IconError, { "data-testid": "error-icon", colorToken: "colors/text/error" }),
                    React.createElement(Typography, { colorToken: "colors/text/error", textToken: "text-style/text/labels/body/regular" }, message)))),
        React.createElement(SpacerVertical, { spaceToken: "space.400" })));
};
ErrorMessage.propTypes = {
    message: PropTypes.string,
};
